interface ICVPurchasePayment {
  personId: number;
  totalCost: number;
  details: CVDetails[];
  paymentType: string;
  cardNumber: string;
  expirationDate: string;
  cardCode: string;
  email: string;
  firstName: string;
  lastName: string;
  companyName: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  recaptcha: string;
}

export class CVPurchasePayment implements ICVPurchasePayment {
  personId = null;
  totalCost = null;
  details = null;
  paymentType = null;
  cardNumber = null;
  expirationDate = null;
  cardCode = null;
  email = null;
  firstName = null;
  lastName = null;
  payerName = null;
  companyName = null;
  address = null;
  city = null;
  state = null;
  zip = null;
  recaptcha = null;  
  dataDescriptor = null;
  dataValue = null;
}

export class CVDetails {
  serviceCodeId: number;
  quantity: number;
  cost: number;
  cvRequest: CVRequest;
}

export class CVRequest {
  cvRequestFor: string;
  email: string;
}
